<template>
  <div class="header">
    <div v-if="headerType===1||headerType===3" class="left">
      <img src="@/assets/img/logo.png" class="logo">
      <h2>在线考试系统</h2>
      <div class="tab">
        <!-- <div class="list" :class="tabIndex===0?'active':''" @click="tabClick(0)">首页<span v-if="tabIndex===0" class="bor" /></div> -->
        <div class="list" :class="tabIndex===1?'active':''" @click="tabClick(1)">考试列表 <span v-if="tabIndex===1" class="bor" /></div>
        <div class="list" :class="tabIndex===2?'active':''" @click="tabClick(2)">视频列表 <span v-if="tabIndex===2" class="bor" /></div>
      </div>
    </div>
    <div v-else-if="headerType===2" class="exam_title">{{ examDetailed.title }}</div>
    <div class="right">
      <i v-if="headerType===1||headerType===3" class="el-icon-s-home" style="font-size: 24px;margin-right: 15px;" @click="goSy" />
      <div v-if="(headerType===1||headerType===3) && userInfo.hospital_id" @click="tabClick(3)">
        <el-badge v-if="msgNum" :value="msgNum" class="item" style="cursor: pointer;">
          <i class="msg-icon el-icon-message-solid" style="cursor: pointer;" />
        </el-badge>
        <i v-else class="msg-icon el-icon-message-solid" style="cursor: pointer;" />
      </div>
      <img :src="userInfo.avatar?userInfo.avatar:require('@/assets/img/defaultProfile.png')" class="avtar">
      <el-dropdown v-if="headerType===1||$route.query.type==='review'" trigger="click" @command="handleCommand($event)">
        <div class="name">
          欢迎，{{ userInfo.realname }}<i class="el-icon-arrow-down icon" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-if="userInfo.hospital_id" command="1" @mouseenter.native="handleEnter(1)" @mouseleave.native="handleLeave()">
            <img v-if="menuIndex===1" src="@/assets/img/person_active.png" class="icons">
            <img v-else src="@/assets/img/person.png" class="icons">
            个人中心</el-dropdown-item>
          <el-dropdown-item v-if="userInfo.hospital&&userInfo.hospital.length>1" command="2" @mouseenter.native="handleEnter(2)" @mouseleave.native="handleLeave()">
            <img v-if="menuIndex===2" src="@/assets/img/switch_active.png" class="icons">
            <img v-else src="@/assets/img/switch.png" class="icons">
            切换医院</el-dropdown-item>
          <el-dropdown-item command="3" @mouseenter.native="handleEnter(3)" @mouseleave.native="handleLeave()">
            <img v-if="menuIndex===3" src="@/assets/img/out_active.png" class="icons">
            <img v-else src="@/assets/img/out.png" class="icons">
            退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown v-else trigger="click">
        <div class="name">
          考生：{{ userInfo.realname }}<i class="el-icon-arrow-down icon" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <div class="test_user">
            <img src="@/assets/img/logo.png" class="user_avatr">
            <div class="user_info">
              <div class="user_name">考生：{{ userInfo.realname }}</div>
              <div class="user_account">账号：{{ userInfo.mobile }}</div>
            </div>
          </div>
        </el-dropdown-menu>
      </el-dropdown>
      <span v-if="headerType===2" class="bor" />
      <img v-if="headerType===2&&!$route.query.type" src="@/assets/img/out.png" class="out" @click="exit">
      <!-- 选择医院 -->
      <changeHospital
        :show-hospital="showHospital"
        :hospital-data="hospitalData"
        @update:showHospital="changeHospitalId"
        @saveId="saveId"
      />
    </div>
    <!-- 提示消息 -->
    <Tips
      ref="tipParmas"
      :tip-parmas="tipParmas"
      @confirm="tipsConfirm"
      @cancel="tipsClose"
    />
    <examStatistics :statistics-type="statisticsType" :statistics-visible="statisticsVisible" :test-info="testInfo" @update:statisticsVisible="statisticsChange" />

  </div>
</template>
<script>
import { userHospital, severTime, getExamDetail,saveCheatBatch, getNotReadNoticeCount } from '@/http/index'
import changeHospital from '../../views/login/child/change.vue'
import { mapState, mapActions } from 'vuex';
import Tips from '../../views/examList/child/tips.vue'
import { dateMinutes2, nowTime } from '@/utils/index'
import { handleAnswer, handleScore } from '@/utils/exam'
import { closeWebsocket } from '@/utils/ws.js'
import examStatistics from '../../views/examList/child/statistics.vue'
import {getCurrentLocation} from '@/utils/location'

export default {
  components: { changeHospital, Tips, examStatistics },
  data() {
    return {
      statisticsType: '0',
      statisticsVisible: false,
      testInfo: {},
      menuIndex: null,
      tabIndex: 1,
      headerType: 1,
      info: this.$store.state.userInfo,
      showHospital: false,
      hospitalData: [],
      tipParmas: {
        tipsVisible: false,
        tipsContent: ''
      },
      date_start: '', // 进入考试的时间
      date_end: '', // 结束考试的时间
      exam_time: '', // 间隔时间秒
      fetchInterval: null,
      addressInfo: {
        lat: 0,
        lng: 0,
        address: '未知',
      },
    }
  },
  computed: {
    ...mapState(['examDetailed', 'userInfo', 'msgNum'])
  },
  watch: {
    '$route': { // $route可以用引号，也可以不用引号  监听的对象
      handler(val) {
        if (val.path === '/home/examinationList' || val.path === '/home/examOutline' || val.path === '/home/examining' || val.path === '/home/review') {
          this.tabIndex = 1;
        } else if (val.path === '/home/videoList') {
          this.tabIndex = 2;
        }
        if ((val.path === '/home/examining' && !val.query.type)) {
          this.headerType = 2;
        } else if (val.path === '/home/examining' && val.query.type) {
          this.headerType = 3;
        }  else {
          this.headerType = 1;
        }
        // 离开正式考试页面时关闭退出考试弹窗，避免弹窗残留到其他页面
        if (val.path !== '/home/examining' || val.query.type) {
          this.tipParmas.tipsVisible = false
        }
        this.date_start = localStorage.getItem('examTimeStart');
      },
      deep: true, // 深度观察监听 设置为 true
      immediate: true // 第一次初始化渲染就可以监听到
    },
    'userInfo.hospital_id': {
      handler(val) {
        if (val) {
          this.clearInterval()
          // 启动消息数量轮询
          this.fetchInterval = this.startMsgNumPolling()
        }
      },
      deep: true,
      immediate: true
    }
  },
  async created() {
    // 启动消息数量轮询
    // this.fetchInterval = this.startMsgNumPolling()
  },

  // 组件销毁时清除定时器
  beforeDestroy() {
    this.clearInterval()
  },
  methods: {
    ...mapActions(['startMsgNumPolling']),
    clearInterval() {
      if (this.fetchInterval) {
        clearInterval(this.fetchInterval)
        this.fetchInterval = null
      }
    },
    statisticsChange() {
      this.statisticsVisible = false;
      this.$router.go(-2);
    },
    tabClick(e) {
      this.tabIndex = e;
      if (this.tabIndex === 1) {
        this.$router.push('/home/examinationList')
      } else if (this.tabIndex === 2) {
        this.$router.push('/home/videoList')
      } else {
        this.$router.push('/home/message')
      }
    },
    async handleCommand(data) {
      if (data === '1') {
        this.$router.push('/home/personal')
      } else if (data === '2') {
        // 切换医院
        const res = await userHospital({
          token: localStorage.getItem('token'),
          secret: localStorage.getItem('secret'),
          hospital_id: localStorage.getItem('hospital_id')
        });
        if (res.code === 200) {
          this.hospitalData = res.data;
          this.showHospital = true;
        }
      } else {
        this.$store.dispatch('loginOut').then(res => {
          this.$router.push('/login')
        })
      }
    },
    goSy() {
      this.$router.push('/')
    },
    saveId(id) {
      this.$message.success('切换成功')
      this.showHospital = false;
      localStorage.setItem('hospital_id', id);
      this.$router.push('/')
      // window.location.reload();
    },
    changeHospitalId() {
      this.hospitalData = [];
      this.showHospital = false
    },
    countUnansweredQuestions(arr) {
      return arr.filter(item => {
        // 如果 type 为 8，判断 value 的长度是否小于 2
        if (item.type == 2 || item.type == 18) {
          return Array.isArray(item.value) && item.value.length < 2;
        }
        // 其他情况判断 value 是否为空或为空数组
        return !item.value || (Array.isArray(item.value) && item.value.length === 0);
      }).length; // 计算未答题目的数量
    },
    exit() {
      const exitRoute = this.$route.fullPath
      severTime().then(res => {
        // 请求返回时已离开原考试页面则不再展示退出考试弹窗
        if (this.$route.fullPath !== exitRoute || this.$route.path !== '/home/examining' || this.$route.query.type) {
          return
        }
        // if (this.examDetailed.submit_minute) { // 设置了最短答题时长
        //   console.log(dateMinutes2(res.data.sever_time, localStorage.getItem('examTimeStart')), '====')
        //   if (this.examDetailed.submit_minute * 60 > dateMinutes2(res.data.sever_time, localStorage.getItem('examTimeStart'))) {
        //     return  this.$message.error(`考试开始${this.examDetailed.submit_minute}分钟后才可交卷`)
        //   }
        // }
        const exams = JSON.parse(localStorage.getItem('testInfo'))
        const examNum = this.countUnansweredQuestions(exams);
        this.tipParmas = {
          tipsContent: examNum > 0 ? `<div>当前还有<span style="color:#DD594A">${examNum}题未作答</span>，是否退出，退出将交卷并结束此次考试？</div>` : `<div>交卷将结束此次考试，是否交卷？</div>`,
          tipsVisible: true,
          confirmText: '交卷',
          cancelText: '取消',
          showClose: true
        }
      })
    },
    tipsClose() {
      this.tipParmas.tipsVisible = false;
    },
     // 修改时间触发作弊
    async isModifyTime(){
      const localTime = new Date().getTime()
      const severTimeRes = await severTime()
      const serverTime = new Date(severTimeRes.data.sever_time).getTime()
      const timeDiff = Math.abs(localTime - serverTime) / 1000  // 转换为秒
      const exam_change_time = localStorage.getItem('examChangeTime')
      if (timeDiff > Number(exam_change_time)) {
        const cheat_data_json = JSON.stringify([{
            exam_id: this.examDetailed.id,
            date_start: localStorage.getItem('examTimeStart'),
            type: 9,
            is_cheat: 2,
            date_time: nowTime(localTime),
            behavior_type: 'end'
          }])
        const res = await saveCheatBatch({
          token: localStorage.getItem('token'),
          secret: localStorage.getItem('secret'),
          hospital_id: localStorage.getItem('hospital_id'),
          cheat_data:cheat_data_json
        })
      }
    },
    async forceConfirm(type) {
      const answer = handleAnswer();
      const unsentArr = handleAnswer(JSON.parse(localStorage.getItem('unsentAnswers') || '[]'))
      const total = handleScore();
      if(this.examDetailed.location_permission_web == 1){
        this.addressInfo = await getCurrentLocation()
      }
      const parmas = {
        token: localStorage.getItem('token'),
        secret: localStorage.getItem('secret'),
        hospital_id: localStorage.getItem('hospital_id'),
        // app_id: this.examDetailed.app_id,
        exam_id: this.examDetailed.id,
        answer: JSON.stringify(unsentArr),
        answer_num: answer.filter(item => item.answer).length,
        exam_date_start: this.examDetailed.reset_answer.is_reset ? this.examDetailed.reset_answer.date_start : localStorage.getItem('examTimeStart'),
        right: answer.filter(item => item.is_right === 1).length,
        score: total < 0 ? 0 : Number.isInteger(total) ? total : total.toFixed(1),
        exam_time: this.examDetailed.reset_answer.is_reset ? Number(this.exam_time) + Number(this.examDetailed.reset_answer.exam_time) : Number(this.exam_time),
        submit_type: type,
        reset: this.examDetailed.reset_answer.is_reset ? 1 : null,
        complete: 1,
        last_answer: localStorage.getItem('nowTopic') ? JSON.parse(localStorage.getItem('nowTopic')).id : '',
        address: this.addressInfo.address,
        lat:this.addressInfo.lat,
        lng:this.addressInfo.lng,
        id: localStorage.getItem('examAnswerId'),
        no_complete: unsentArr.length > 0 ? 0 : 1,
      }
      this.$store.dispatch('onceSubmit', parmas).then(async res => {
        if (res.code === 200) {
          this.$message.success("提交成功");
          await this.isModifyTime()
          this.$refs.tipParmas.btnChange(false)
          this.tipParmas.tipsVisible = false;
          localStorage.removeItem('testInfo')
          localStorage.removeItem('unsentAnswers')
          localStorage.removeItem('examId')
          localStorage.removeItem('testPaper')
          localStorage.removeItem('examTimeStart')
          localStorage.removeItem('nowTopic')
          localStorage.removeItem('stayTime')
          closeWebsocket();
          this.testInfo = {
            avatar: this.$store.state.userInfo.avatar,
            realname: this.$store.state.userInfo.realname,
            score: parmas.score < 0 ? 0 : parmas.score,
            time: parmas.exam_time,
            pass: parmas.score >= this.examDetailed.pass_score ? '及格' : '不及格',
            exam_id: this.examDetailed.id,
            exam_name: this.examDetailed.title,
            rate: Math.trunc((parmas.score / this.examDetailed.score) * 100),
            review_option: this.examDetailed.review_option ? this.examDetailed.review_option.split(',') : ''
          }
          this.statisticsVisible = true;
        }
      }).catch(err => {
        this.$refs.tipParmas.btnChange(false)
      })
    },
    async tipsConfirm() {
      this.$refs.tipParmas.btnChange(true)
      const res = await severTime()
      this.date_end = res.data.sever_time;
      this.exam_time = dateMinutes2(res.data.sever_time, this.date_start ? this.date_start : localStorage.getItem('examTimeStart'))
      // this.exam_time = localStorage.getItem('stayTime')
      const queryData = {
        token: localStorage.getItem('token'),
        secret: localStorage.getItem('secret'),
        hospital_id: localStorage.getItem('hospital_id'),
        exam_id: this.examDetailed.id
      }
      getExamDetail(queryData).then(res3 => {
        if (res3.code == 200) {
          // 判断最短答题时长
          const time2 = res3.data.submit_minute * 60
          if (res3.data.reset_answer && res3.data.reset_answer.is_reset) { // 重置过逻辑
            console.log(time2, Number(this.exam_time), Number(res3.data.reset_answer.exam_time), Number(this.exam_time) + Number(res3.data.reset_answer.exam_time))
            if (time2 > Number(this.exam_time) + Number(res3.data.reset_answer.exam_time)) {
              this.$refs.tipParmas.btnChange(false)
              return  this.$message.error(`考试开始${res3.data.submit_minute}分钟后才可交卷`)
            }
          } else {
            if (time2 > this.exam_time) {
              this.$refs.tipParmas.btnChange(false)
              return  this.$message.error(`考试开始${res3.data.submit_minute}分钟后才可交卷`)
            }
          }
          this.forceConfirm(0)
        } else {
          this.$refs.tipParmas.btnChange(false)
          if (res3.message == "您已被管理员强制交卷，有问题请联系管理员") {
            this.forceConfirm(6);
          }
          if (res3.message === "本场考试已取消" || res.message === '您已被移出本场考试') {
            localStorage.removeItem('examId')
            localStorage.removeItem('testInfo')
            localStorage.removeItem('unsentAnswers')
            localStorage.removeItem('examTimeStart')
            localStorage.removeItem('testPaper')
            localStorage.removeItem('nowTopic')
            localStorage.removeItem('stayTime')
            this.$router.go(-2);
          }
        }
      }).catch(err2 => {
        this.$refs.tipParmas.btnChange(false)
      })
    },
    handleEnter(i) {
      this.menuIndex = i;
    },
    handleLeave() {
      this.menuIndex = null;
    }

  }
}
</script>
<style scoped>
.el-dropdown-menu,.el-dropdown,.el-popper{
      padding: 0 !important;
    }
</style>
<style lang="scss" scoped>
.msg-icon{
  font-size: 24px;
}
::v-deep{
  .el-badge__content.is-fixed{
    top: 1px;
    right: 9px;
  }
    .icons{
        width: 16px;
        margin-right: 4px;
    }

    .test_user{
        display: flex;
        align-items: center;
        padding: 6px 16px !important;

        .user_avatr{
            width: 40px;
            height: 40px;
            border-radius: 50%;
        }
        .user_info{
            margin-left: 8px;
            .user_name{
                font-size: 14px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #303030;
            }
            .user_account{
                font-size: 12px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #909090;
                margin-top: 4px;
            }
        }
    }
    .el-dropdown-menu__item {
      display: flex;
      align-items: center;
      color: #606266;
      &:hover {
        background-color: #FFF6F4;
        color:#DD594A;
        .icons{
          color: red;
        }
      }
    }

    // .el-dropdown-menu__item.is-active {
    //   color: #409EFF;
    //   background-color: #ecf5ff;
    // }

    // .el-dropdown-menu__item.is-disabled {
    //   color: #409EFF;
    //   background-color:  #ecf5ff;
    // }

}

.header{
    // padding: 16px 24px;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    .exam_title{
        font-size: 18px;
        font-family: Source Han Sans CN-Medium, Source Han Sans CN;
        font-weight: 500;
        color: #303030;
    }
    .left{
        display: flex;
        align-items: center;
        height: 100%;

        .logo{
            width: 24px;
        }
        h2{
            margin-left: 8px;
            font-size: 18px;
            color: #303030 ;
            line-height: 1;
        }
        .tab{
            margin-left: 64px;
            display: flex;
            align-items: center;
            height: 100%;
            .list{
                display: flex;
                align-items: center;
                height: 100%;
                line-height: 1;
                margin-right: 48px;
                font-size: 16px;
                color: #303030 ;
                position: relative;
            }
            .active{
                color: #DD594A ;
                // border-bottom: 2px solid #DD594A;
            }
            .bor{
              display: inline-block;
              width: 24px;
              height: 2px;
              background: #DD594A;
              position: absolute;
              bottom: 0;
              left: calc(50% - 12px);
            }
        }
    }
    .right{
        display: flex;
        align-items: center;
        .el-dropdown{
            display: flex;
            align-items: center;

        }
        .avtar{
            width: 24px;
            height: 24px;
            border-radius: 50%;
            margin-right: 4px;
            margin-left: 20px;
        }
        .name{
            font-size: 14px;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            color: #303030;
            .icon{
                margin-left: 4px;
            }
        }
        .bor{
            width: 1px;
            height: 12px;
            background: #EEEEEE;
            margin: 0 16px;
        }
        .out{
            width: 18px;
        }

    }

}
</style>
